// extracted by mini-css-extract-plugin
export default {"mainContainer":"Obs_mainContainer__qMNZw","lastMainContainer":"Obs_lastMainContainer__cYzl0"};